/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_BAND = gql`
  query GetBand($filter: BandInput) {
    getBand(filter: $filter) {
      bandId
      bandName
      isChangeCostumeEnabled
      bandLogo
      primaryTheme
      secondaryTheme
      isMultiplePurchase
      inviteExpireTime
      openRegEnabled
      isUpdateExpiryEnabled
      sidebar {
        enabled
        name
      }
      enableNameCheck
      blockedNames {
        email
        emailEnabled
        firstName
        firstNameEnabled
        lastName
        lastNameEnabled
      }
    }
  }
`;
